import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";

// Get All Court Types (with optional query params)
export async function getCourtTypes({ queryParams, placeId, isAllCourt, isActive }) {
  try {
    const response = await axios.Get({
      url: `${adminUrl}/court-type-list`,
      params: {
        queryParams: queryParams || '',
        isAllCourt: isAllCourt || '',
        isActive: isActive || '',
        placeId: placeId || ''
      },
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

// Get Court Type by ID
export async function getCourtType(id) {
  try {
    const response = await axios.Get({
      url: `${adminUrl}/court-type/${id}`,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

// Create Court Type
export async function createCourtType(data) {
  try {
    const response = await axios.Post({
      url: `${adminUrl}/court-type-create`,
      data,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

// Update Court Type
export async function updateCourtType(data) {
  try {
    const response = await axios.Post({
      url: `${adminUrl}/court-type-update`,
      data,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getSportTypeOptions({ queryParams, isActive }) {
  try {
    const response = await axios.Get({
      url: `${adminUrl}/sport-type-list`,
      params: {
        queryParams: queryParams || '',
        isActive: isActive || ''
      },
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}